module.exports = __webpack_public_path__ + "img/optionchain2.b5f65a84.png";